import { getYear } from "@/utils/getYear";

type FooterProps = {
    position?: "fixed" | "static" | ""
}

export default function Footer({ position = "" }: FooterProps) {
    const className = position === "fixed" ? [
        "fixed",
        "bottom-2",
        "sm:bottom-4",
        "right-2",
        "sm:right-4",
        "text-xs",
        "text-[var(--foreground)]",
        "z-30"
    ].join(" ") : position === "static" ? [
        "relative",
        "md:absolute",
        "bottom-2",
        "sm:bottom-4",
        "right-2",
        "sm:right-4",
        "text-xs",
        "text-[var(--foreground)]",
        "z-30",
        "text-right",
        "pr-4",
        "pb-2",
        "sm:pr-0",
        "sm:pb-0"
    ].join(" ") : [
        "absolute",
        "bottom-2",
        "sm:bottom-4",
        "right-2",
        "sm:right-4",
        "text-xs",
        "text-[var(--foreground)]",
        "z-30"
    ].join(" ");

    return (
        <footer className={className}>
            © {getYear()} Augusto Leite
        </footer>
    );
}